module.exports = __webpack_public_path__ + "static/media/taiwan-gray.dffcb2fc.svg";